/**
 * Trigger: tr_accounts_update_position
 * Purpose: Handle position conflicts when account position is updated
 * Table: accounts
 * Event: AFTER UPDATE OF position
 */
export const TR_ACCOUNTS_UPDATE_POSITION = `
CREATE TRIGGER tr_accounts_update_position
AFTER UPDATE OF position ON accounts
BEGIN
  UPDATE accounts
  SET position = old.position,
      updated_at = strftime('%s', 'now')
  WHERE _id <> new._id
    AND new.position = position
    AND is_deleted = 0;
END;
`;
